<div
  class="hero-shell w-full bg-cover bg-center flex items-center justify-center"
  [class.hero-shell-closed]="!heroVisible()"
  style="background-image: url(&quot;assets/landing.jpg&quot;)">
  @if (heroVisible()) {
    <gate-maintenance-banner [collapsed]="false" (bannerVisibilityChange)="onMaintenanceBannerVisibilityChange($event)" />
  }
  @if (heroVisible() && !maintenanceBannerVisible() && !isImpersonatingAsAcpUser()) {
    <div class="absolute top-3 right-2 lg:z-[999] z-20">
      <button
        pButton
        type="button"
        size="small"
        class="hero-close-button"
        icon="pi pi-times"
        [label]="'closeButton' | translate"
        [attr.aria-label]="'closeButton' | translate"
        (click)="toggleHeroVisible()"></button>
    </div>
  }
  <div
    class="hero-content p-4 xl:p-0 items-center"
    [class.hero-content-hidden]="!heroVisible()"
    [attr.aria-hidden]="heroVisible() ? null : 'true'"
    [attr.inert]="heroVisible() ? null : ''">
    <div class="w-auto md:w-[600px] xl:w-[658px] mb-16">
      <div class="md:w-[80%] w-full m-auto">
        <p class="text-xl text-white">{{ "hero.headerTitle" | translate }}, {{ user().givenName }}&nbsp;{{ user().familyName }}</p>
        <p class="pt-4 text-5xl text-white font-['Apex_Rounded_Medium']">{{ "hero.headerSubtitle" | translate }}</p>
        <div class="mt-6">
          @if(heroVisible()){
          <gate-searchbar></gate-searchbar>
          }
        </div>
      </div>
    </div>
    <gate-external-portals />
  </div>
</div>

